import { render } from "./SvgBase.vue?vue&type=template&id=11491904"
import script from "./SvgBase.vue?vue&type=script&lang=ts"
export * from "./SvgBase.vue?vue&type=script&lang=ts"
script.render = render

export default script